import React, { useState, useEffect } from 'react';

const SubtractionProblem = (props) => {
    const getClassName = () => {
        if (props.alignment == "horizontal") {
            return "subtraction-problem-horizontal"
        }
        return "subtraction-problem"
    }

    return <div class={getClassName()}>
            {props.rows.map((row) => <span class="subtraction-row">{row}</span>)}
            <span class="equal">&nbsp;=&nbsp;</span>
            <span class="answer-line">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    </div>;
}

export default SubtractionProblem;

